var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavAngleDown = function SvgNavAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    fill: "none",
    viewBox: "0 0 13 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c10c6d",
    fillRule: "evenodd",
    d: "M6.4 5.604.796 0 0 .796l6.4 6.4 6.4-6.4L12.004 0z",
    clipRule: "evenodd"
  })));
};
export default SvgNavAngleDown;